import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import { FilingEventModel } from '../../../../../../models/aggregates/erp/financial-filing';

@Injectable({providedIn: 'root'})
export class FilingEventService extends BaseApiTemplateService<FilingEventModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'filing-events';

  constructor(private http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'filing-events';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'filing-events';
    this.httpClient = http;
  }


}
